import { gql, useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { Card, CircularProgress, Fade, Grid, Icon, Modal, Tooltip } from "@mui/material";
import SoftBox from "components/CheckBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { getUproColor } from "utils/colors";
import SoftInput from "components/SoftInput";
import SinDatos from "components/Carteles/SinDatos";
import dayjs from "dayjs";
import dataModalReservas from "./dataModalReservas";
// Kaizen Dashboard base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import DataTable from "components/Tables/DataTable";

export default function ModalReservas({
  open,
  handleClose,
  selected,
  setSelected,
  reservas,
  loadingReservasPendientes,
  setModalAddOT,
  fecha,
  setFecha,
}) {
  useEffect(() => {
    if (open) {
      setSelected(null);
    }
  }, [open]);

  const [getReservados, { data: dataResevasPendientes, loading: loadingReservas }] = useLazyQuery(
    gql`
      query getReservasPendientes($fecha: String) {
        reservadosHoy(fecha: $fecha) {
          idProducto
          productoNombre
          total
          horaReserva
          turnoReserva
          estado
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
    }
  );

  const { columns, getRows } = dataModalReservas;
  const [pedidosMediodia, setPedidosMediodia] = useState([]);
  const [pedidosNoche, setPedidosNoche] = useState([]);

  useEffect(() => {
    if (reservas) {
      setPedidosMediodia(reservas?.filter((r) => r.turnoReserva == "Mediodía"));
      setPedidosNoche(reservas?.filter((r) => r.turnoReserva == "Noche"));
    }
  }, [reservas]);

  const handleSelect = (item) => {
    setSelected((prev) => (prev?.idProducto !== item?.idProducto ? item : null));
  };
  console.log(reservas);
  return (
    <Modal open={open} onClose={handleClose} closeAfterTransition>
      <Fade in={open}>
        <Card
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxHeight: "90%",
            width: { xs: "70%", sm: "70%" },
            overflow: "auto",
            p: 3,
          }}
        >
          <SoftBox display="flex" justifyContent="space-between" alignItems="center">
            <SoftTypography variant="h6">Reservas Pendientes</SoftTypography>
            <Tooltip title="Cerrar" placement="top">
              <SoftButton
                circular
                iconOnly
                color="error"
                variant="gradient"
                onClick={() => {
                  setSelected(null);
                  setFecha(dayjs().format("YYYY-MM-DD"));
                  handleClose();
                }}
              >
                <Icon>close</Icon>
              </SoftButton>
            </Tooltip>
          </SoftBox>

          <SoftBox
            display="inline-grid"
            gridTemplateColumns="1fr auto 2fr"
            gap={2}
            alignItems="center"
            p={2}
            mt={2}
          >
            <SoftTypography variant="button" fontWeight="bold">
              Fecha de reserva
            </SoftTypography>
            <SoftInput
              name="fecha"
              type="date"
              sx={{ cursor: "pointer", width: "auto" }}
              value={fecha}
              onChange={(e) => {
                setFecha(e.target.value);
              }}
            />
          </SoftBox>

          <SoftBox
            display="flex"
            flexDirection="column"
            gap={2}
            sx={{ overflowY: "auto", maxHeight: { xs: "90vh", sm: "50vh" } }}
            p={2}
          >
            <SoftTypography variant="button" fontWeight="bold">
              Turno Mediodía
            </SoftTypography>
            <DataTable columns={columns} rows={getRows(pedidosMediodia)} />
          </SoftBox>

          <SoftBox
            display="flex"
            flexDirection="column"
            gap={2}
            sx={{ overflowY: "auto", maxHeight: { xs: "90vh", sm: "50vh" } }}
            p={2}
          >
            <SoftTypography variant="button" fontWeight="bold">
              Turno Noche
            </SoftTypography>
            <DataTable columns={columns} rows={getRows(pedidosNoche)} />
          </SoftBox>

          <SoftBox display="flex" justifyContent="flex-end" alignItems="center" mt={2}>
            <SoftButton
              variant="gradient"
              color="primary"
              circular
              disabled={!selected || dayjs(fecha).isBefore(dayjs(), "day")}
              onClick={() => {
                setModalAddOT(true);
                handleClose();
              }}
            >
              <Icon fontSize="large">factory</Icon>&nbsp; Generar orden de trabajo
            </SoftButton>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalReservas.defaultProps = {
  open: false,
  handleClose: () => {},
  idUser: null,
};

ModalReservas.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  idUser: PropTypes.number,
  reservas: PropTypes.array,
  loadingReservasPendientes: PropTypes.bool,
  selected: PropTypes.object,
  setSelected: PropTypes.func,
  setModalAddOT: PropTypes.func,
  fecha: PropTypes.any,
  setFecha: PropTypes.func,
};
